module.exports = __webpack_public_path__ + "static/media/mpg.a12de3ea.png";